export default function HttpConfiguratorRun($httpConfigurator) {
	"ngInject";
	$httpConfigurator.setDefaultsHeaders();
}


// WEBPACK FOOTER //
// ./sources/bootstrap/http.run.js